import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=5bd07ece"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports